import React, { PureComponent } from 'react'
import styled from 'styled-components'
import { TreeSelect } from 'antd'
import ComparativeReport from '../containers/comparative-report'
import { PHONELG } from '../utilities/breakpoints'

class StatisticsPageComparativeReport extends PureComponent {

  getSelectLabelText = (crSection, useTranslate) => {
    switch (crSection) {
      case 'themes':
        return useTranslate('comparative_reports.select_theme');
      case 'drivers':
        return useTranslate('comparative_reports.select_driver');
      case 'statements':
        return useTranslate('comparative_reports.select_statement');
      default:
        return "";
    }
  }

  getInstructionText = (crSection, useTranslate) => {
    switch (crSection) {
      case 'themes':
        return useTranslate('comparative_reports.select_theme_instruction');
      case 'drivers':
        return useTranslate('comparative_reports.select_driver_instruction');
      case 'statements':
        return useTranslate('comparative_reports.select_statement_instruction');
      default:
        return "";
    }
  }

  getSelectListItems = (crSection, catalysts) => {
    switch (crSection) {
      case 'themes':
        return catalysts.map((theme) => {
          return {label: theme.title, value: theme.id}
        }).flat();
      case 'drivers':
        return catalysts.map((theme) => {
          return theme.drivers.map((driver) => {
            return {label: driver.title, value: driver.id}
          })
        }).flat();
      case 'statements':
        return catalysts.map((theme) => {
          return theme.questions.map((statement) => {
            return {label: statement.title, value: statement.id}
          }).flat()
        }).flat();
      default:
        return [];
    }
  }

  getCurrentListValue = (crSection, crReportIds) => {
    switch (crSection) {
      case 'themes':
        return crReportIds.themeId;
      case 'drivers':
        return crReportIds.driverId;
      case 'statements':
        return crReportIds.statementId;
      default:
        return null;
    }
  }

  render() {
    const {
      questionnaire: {
        catalysts,
        isAfterGameGuest
      },
      match,
      useTranslate,
      crSection,
      crReportIds,
      onSetCrReportIds
    } = this.props;

    let selectListItems = this.getSelectListItems(crSection, catalysts);
    selectListItems.unshift({
      "label": useTranslate("parameters.select_menu_default_text"),
      "value": null
    })

    const handleReportChange = (val) => {
      switch (crSection) {
        case 'themes':
          onSetCrReportIds({...crReportIds, themeId: val})
          break;
        case 'drivers':
          onSetCrReportIds({...crReportIds, driverId: val})
          break;
        case 'statements':
          onSetCrReportIds({...crReportIds, statementId: val})
          break;
        default:
          onSetCrReportIds({...crReportIds})
      }
    }

    return (
      <Wrapper id="dropdown-area">
        {crSection !== "overall" &&
          <SelectContainer>
            <label htmlFor={"selectReport"}>{this.getSelectLabelText(crSection, useTranslate)}</label>
            <TreeSelect
              dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
              treeData={selectListItems}
              treeDefaultExpandAll
              treeCheckStrictly={true}
              showArrow={true}
              value={this.getCurrentListValue(crSection, crReportIds)}
              onChange={handleReportChange}
              getPopupContainer={() => document.getElementById('dropdown-area')}
              id="selectReport"
            />
          </SelectContainer>
        }
        {(this.getCurrentListValue(crSection, crReportIds) || crSection === "overall") ?
          <ComparativeReport
            crSection={crSection}
            crReportId={this.getCurrentListValue(crSection, crReportIds)}
            match={match}
            catalysts={catalysts}
            isAfterGameGuest={isAfterGameGuest}
          />
          :
          <InstructionText>
            {this.getInstructionText(crSection, useTranslate)}
          </InstructionText>
        }

      </Wrapper>
    );
  }
}

export default StatisticsPageComparativeReport;

const Wrapper = styled.div`
  position: relative;
  
  .ant-select-tree-dropdown .ant-select-tree li {
    font-size: 14px;
  }
`;

const SelectContainer = styled.div`
  max-width: 600px;
  margin-bottom: 32px;
  
  .ant-select {
    max-width: 400px;
  }
  
  label {
    font-size: 14px;
    font-weight: 500;
    margin-right: 7px;
    margin-bottom: 0;
    white-space: nowrap;
  }
  
  @media${PHONELG} {
    max-width: none;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }
`;

const InstructionText = styled.div`
  color: #5F7D95;
  font-weight: 500;
  text-align: center;
  font-size: 20px;
  padding: 100px 0;
  opacity: .6;
  border: 1px solid #DEE1E6;
  border-radius: 10px;
  //background-color: #fafafa;
`



// WEBPACK FOOTER //
// ./src/components/statistics-page-comparative-report.js